'use client'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { debounce } from 'lodash'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { fetchPatienten } from '../apiCalls/usersApi'

const SelectPatienten = ({ selected, setSelected, text = "Zoek op patient" }) => {
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { patienten } = useSelector(state => state.user);
  const [data, setData] = useState(patienten);

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      fetchPatienten(50, 0, searchQuery, setLoading, setError, setData);
    }, 300),
    []
  );

  const labelCls = "block text-sm font-medium text-wa-muted";
  const inputCls =
    "block w-full rounded-lg border border-wa-border bg-wa-panel py-2 pl-3 pr-10 text-sm text-wa-text outline-none placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent";
  const optionsCls =
    "absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-lg border border-wa-border bg-wa-panel2 py-1 text-sm shadow-xl ring-1 ring-black/20 focus:outline-none";
  const optionCls =
    "group relative cursor-default select-none py-2 pl-3 pr-9 text-wa-text data-[focus]:bg-wa-hover data-[focus]:outline-none";
  const chevronCls = "size-5 text-wa-muted";

  return (
    <Combobox
      as="div"
      value={selected || data[0]}
      onChange={(person) => {
        setQuery('')
        setSelected(person)
      }}
    >
      {text && <Label className={labelCls}>{text}</Label>}
      <div className="relative mt-2">
        <ComboboxInput
          className={inputCls}
          onChange={(event) => {
            setQuery(event.target.value);
            debouncedSearch(event.target.value);
          }}
          onBlur={() => setQuery('')}
          displayValue={(person) => person?.full_name}
        />
        <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className={chevronCls} aria-hidden="true" />
        </ComboboxButton>

        {data.length > 0 && (
          <ComboboxOptions className={optionsCls}>
            {data.map((person) => (
              <ComboboxOption
                key={person.id}
                value={person}
                className={optionCls}
              >
                <div className="flex items-center text-wa-text">
                  <img src={person?.avatar} alt="" className="size-6 shrink-0 rounded-full" />
                  <span className="ml-3 truncate group-data-[selected]:font-semibold">{person?.full_name}</span>
                </div>

                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-wa-accent group-data-[selected]:flex group-data-[focus]:text-wa-accent">
                  <CheckIcon className="size-5" aria-hidden="true" />
                </span>
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}
      </div>
    </Combobox>
  )
}

export default SelectPatienten;
